import React, {useCallback, useState} from "react";
import styles from "./styles.scss";
import {connect} from "react-redux";
import {getActualPage, getMagazine, getTranslation} from "../../../../store/getters";
import {editMagazine, toggleToaster} from "../../../../store/actions";

function MagazineEditorTitle({translation, magazine, actualPage, editMagazine, toggleToaster}) {
    const defaultTitle = magazine.title !== "\0" ? magazine.title : "";

    const [delay, setDelay] = useState(0);
    const [title, setTitle] = useState(defaultTitle);

    const onChangeTitle = useCallback(e => {
        if (delay) clearTimeout(delay);
        const title = e.target.value;
        if (title) setDelay(setTimeout(() => {
            editMagazine(magazine.id, {...magazine, title});
            toggleToaster({
                isVisible: true,
                message: translation("general-magazine-edit-success"),
                position: "top-right",
                type: "success",
            });
        }, 500));
        setTitle(title);
    }, [delay]);

    return (
        <div className={styles.container}>
            {translation("general-page")} {actualPage?.page_position}
            &nbsp;-&nbsp;
            <input className={styles.title} placeholder={translation("magazine-card-untitled")} value={title} onChange={onChangeTitle}/>
        </div>
    );
}

export default connect(state => {
    const translation = getTranslation(state);
    const magazine = getMagazine(state);
    const actualPage = getActualPage(state);
    return {translation, magazine, actualPage};
}, {
    editMagazine,
    toggleToaster,
})(MagazineEditorTitle);


// WEBPACK FOOTER //
// ./src/components/Heade/components/MagazineTitleEditable/index.js